import { Answer } from './index'

const mapAnswerToProbableAnswer = (answer: Answer): number => answer.id

export default mapAnswerToProbableAnswer
